import { render, staticRenderFns } from "./align-self.vue?vue&type=template&id=362a0048&"
import script from "./align-self.vue?vue&type=script&lang=js&"
export * from "./align-self.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports